<template>
  <div class="dashboard-pages">
    <v-card>
      <form @submit.prevent="submit()">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="search"
                label="Search Menu"
                box
                hide-details
                background-color="white"
                clearable
                clear-icon="mdi-close"
              />
            </v-flex>

            <v-flex xs12 pl-4 pr-4>
              <v-checkbox v-model="grandAll" color="indigo">
                <template v-slot:label>
                  <strong class="grey--text text--darken-3">{{ $t('Grand All') }}</strong>
                </template>
              </v-checkbox>
            </v-flex>

            <v-flex xs12 v-if="!grandAll">
              <v-treeview
                v-model="tree"
                :items="items"
                active-class="grey lighten-4 indigo--text"
                selected-color="indigo"
                selectable
                open-on-click
                :open.sync="open"
                :search="search"
                :filter="filter"
                expand-icon="mdi-chevron-down"
              >
                <template v-slot:label="{ item }">{{ $t(item.name.trim()) }}</template>
              </v-treeview>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider light />

        <v-card-actions>
          <v-layout justify-start>
            <v-btn flat @click="tree = getChildren()">Reset</v-btn>
          </v-layout>
          <v-layout justify-end>
            <v-btn type="submit" color="success" :loading="btnUpdateLoading">
              <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
              {{ $t('Update') }}
            </v-btn>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'system-features',

  data() {
    return {
      btnUpdateLoading: false,
      grandAll: false,
      tree: [],
      items: [],
      open: [],
      search: null
    }
  },

  computed: {
    ...mapGetters({
      systemMenu: 'features/getSystemMenu'
    }),

    filter() {
      return this.caseSensitive ? (item, search, textKey) => item[textKey].indexOf(search) > -1 : undefined
    }
  },

  mounted() {
    this.fetchSystemMenu()
    this.setAppBarTitle({
      title: this.$t('System Features'),
      icon: 'fa-cogs'
    })
  },

  watch: {
    systemMenu: {
      immediate: false,
      handler() {
        this.items = this.systemMenu.sidebars_tree
        this.tree = this.getChildren()
        this.open = []
        this.grandAll = false
      }
    }
  },

  methods: {
    ...mapActions({
      fetchSystemMenu: 'features/fetchSystemMenu',
      updateSystemMenu: 'features/updateSystemMenu'
    }),

    getChildren() {
      let parents = [1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
      return this.systemMenu.active_sidebar.filter(item => !parents.includes(item))
    },

    getParents(children) {
      let parents = []

      const parentsOfChildren = [
        { from: 31, to: 34, parents: [1, 8] },
        { from: 35, to: 36, parents: [1, 9] },
        { from: 37, to: 38, parents: [1, 10] },
        { from: 39, to: 42, parents: [1, 11] },
        { from: 89, to: 89, parents: [1, 11] },
        { from: 43, to: 44, parents: [1, 12] },
        { from: 90, to: 90, parents: [1, 12] },
        { from: 45, to: 48, parents: [1, 13] },
        { from: 49, to: 50, parents: [1, 14] },
        { from: 51, to: 52, parents: [1, 15] },
        { from: 53, to: 54, parents: [1, 16] },
        { from: 55, to: 59, parents: [2, 17] },
        { from: 60, to: 61, parents: [2, 18] },
        { from: 62, to: 63, parents: [2, 19] },
        { from: 64, to: 68, parents: [2, 20] },
        { from: 69, to: 73, parents: [3, 21] },
        { from: 74, to: 79, parents: [3, 22] },
        { from: 80, to: 87, parents: [3, 23] },
        { from: 24, to: 25, parents: [5] },
        { from: 26, to: 28, parents: [6] },
        { from: 29, to: 30, parents: [7] },
        { from: 88, to: 88, parents: [7] }
      ]

      for (let index = 0; index < children.length; index++) {
        let newParents = parentsOfChildren
          .filter(item => item.from <= children[index] && item.to >= children[index])
          .map(item => item.parents)[0]

        if (newParents !== undefined) {
          parents.push(...newParents)
        }
      }

      return [...new Set(parents)]
    },

    submit() {
      this.btnUpdateLoading = true

      let formData = new FormData()
      if (this.grandAll) {
        formData.append('all', 'all')
      } else {
        const oldParents = this.tree
        const newParents = this.getParents(this.tree)
        let parents = []

        if (oldParents === []) {
          parents.push(...newParents)
        } else if (newParents === []) {
          parents.push(...oldParents)
        } else {
          parents.push(...oldParents)
          parents.push(...newParents)
          parents = [...new Set(parents)]
        }

        parents.forEach((p, index) => {
          formData.append('id[' + [index] + ']', p)
        })
      }

      this.updateSystemMenu(formData)
        .then(() => {
          this.btnUpdateLoading = false
        })
        .catch(() => {
          this.btnUpdateLoading = false
        })
    }
  }
}
</script>

<style scoped />
